<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'form'">
    <app-template [title]="'Result Dispatch'">
      <div class="data">
        <div
          *ngIf="isLoading"
          style="margin-top: 200px; padding-bottom: 500px"
          class="spinner"
        >
          <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Service Name</th>
            <th>Dispatched To Reception</th>
            <th>Dispatched To Patient</th>
            <th>No. Printed</th>
            <th>Patient Name</th>
            <th>
              <!-- <button  mat-raised-button color="basic">
                            Clear All
                          </button> -->
            </th>
          </tr>
          <tr class="td" *ngFor="let item of data" style="cursor: pointer">
            <td *ngIf="item.is_finalized == 'N'">{{ item.service_name }}</td>
            <td
              style="background-color: green; color: white"
              *ngIf="item.is_finalized == 'Y'"
            >
              {{ item.service_name }}
            </td>
            <td *ngIf="item.is_dispatched_to_reception == 'N'">
              {{ item.is_dispatched_to_reception }}
            </td>
            <td *ngIf="item.is_dispatched_to_reception == 'Y'">
              <img
                style="width: 30px; height: 30px"
                src="assets/icons/done.gif"
                alt=""
              />
            </td>
            <td *ngIf="item.is_dispatched_to_patient == 'N'">
              {{ item.is_dispatched_to_patient }}
            </td>
            <td *ngIf="item.is_dispatched_to_patient == 'Y'">
              <img
                style="width: 30px; height: 30px"
                src="assets/icons/done.gif"
                alt=""
              />
            </td>
            <td>{{ item.print_no }}</td>
            <td>{{ item.patient_name }}</td>
            <td>
              <button
                (click)="addRecord(item)"
                mat-raised-button
                color="primary"
              >
                Dispatch
              </button>
            </td>
          </tr>
        </table>
      </div>
    </app-template>
  </div>
  <div class="wizwig" *ngSwitchCase="'wiz'">
    <app-template [title]="'Format Result'">
      <div class="form">
        <div
          id="print-section"
          style="display: none; width: 500px; margin: auto"
          [innerHTML]="Template_Text"
        ></div>
        <button
          (click)="back()"
          type="button"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>
        <button
          (click)="dispatchResultPatient()"
          style="width: 160px"
          type="button"
          class="create"
          *ngIf="!dispatchPatientLoad"
          mat-raised-button
          color="primary"
        >
          Dispatch To Patient
        </button>
        <button
          type="button"
          class="create"
          style="width: 160px"
          mat-raised-button
          color="primary"
          *ngIf="dispatchPatientLoad"
        >
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>

        <button
          (click)="dispatchResultReception()"
          style="width: 180px"
          type="button"
          class="create"
          *ngIf="!dispatchReceptionLoad"
          mat-raised-button
          color="primary"
        >
          Dispatch To Reception
        </button>
        <button
          type="button"
          style="width: 180px"
          class="create"
          mat-raised-button
          color="primary"
          *ngIf="dispatchReceptionLoad"
        >
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>

        <div class="space"></div>

        <div class="name">Turn Around Time</div>
        <table border="0">
          <tr [style.background]="collect">
            <td>Samples Collected</td>
            <td>
              {{ record?.sample_collect_date | date }}
              <div style="color: red">
                {{ record?.sample_collect_date | date: "mediumTime" }}
              </div>
            </td>
          </tr>
          <tr [style.background]="acknowledge">
            <td>Samples Acknowleged</td>
            <td>
              {{ record?.sample_acknowledge_date | date }}
              <div style="color: red">
                {{ record?.sample_acknowledge_date | date: "mediumTime" }}
              </div>
            </td>
          </tr>
          <tr [style.background]="type">
            <td>Results Typed</td>
            <td>
              {{ record?.result_date | date }}
              <div style="color: red">
                {{ record?.result_date | date: "mediumTime" }}
              </div>
            </td>
          </tr>
          <tr [style.background]="finalize">
            <td>Results Finalized</td>
            <td>
              {{ record?.finalized_date | date }}
              <div style="color: red">
                {{ record?.finalized_date | date: "mediumTime" }}
              </div>
            </td>
          </tr>

          <tr [style.background]="reception">
            <td>Results Dispatched(reception)</td>
            <td>
              {{ record?.date_dispatched_to_reception | date }}
              <div style="color: red">
                {{ record?.date_dispatched_to_reception | date: "mediumTime" }}
              </div>
            </td>
          </tr>
          <tr [style.background]="patient">
            <td>Results Dispatched(patient)</td>
            <td>
              {{ record?.date_dispatched_to_patient | date }}
              <div style="color: red">
                {{ record?.date_dispatched_to_patient | date: "mediumTime" }}
              </div>
            </td>
          </tr>
        </table>
        <div class="space"></div>
        <form [formGroup]="stateForm" (ngSubmit)="Submit($event)">
          <angular-editor
            [config]="editorConfig"
            [placeholder]="'Enter text here...'"
            formControlName="formatstr"
          ></angular-editor>
        </form>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
            <p>{{ Errors }}</p>
          </div>
        </div>
        <div class="space"></div>
      </div>
    </app-template>
  </div>
</div>
